import { parseISO } from 'date-fns';

import { ROW_HEIGHT } from './constants/virtualDataTable';

export const getFilters = (report) => {
  const { startDate, endDate, ...rest } = report;

  const filters = {
    ...rest,
    date: [parseISO(startDate), parseISO(endDate)],
  };

  return filters;
};

export const ifGroup = (index, data, groupBy) => {
  return groupBy && (index == 0 || data[index - 1]?.[groupBy][0] !== data[index]?.[groupBy][0]);
};

export const groupByMap = new Map([
  ['rider', 'riders'],
  ['category', 'categories'],
  ['residence_district', 'residenceDistrict'],
]);

export const getRowHeight = (index, data) => {
  const tagsHeight = data[index]?.tags?.length * 32;
  const ridersHeight = data[index]?.riders?.length * 29;
  const categoriesHeight = data[index]?.categories?.length * 45;
  const cancelReasonHeight = data[index]?.cancelReason ? data[index]?.cancelReason.split(' ').length * 12 : 0;

  return Math.max(tagsHeight, ridersHeight, categoriesHeight, cancelReasonHeight, ROW_HEIGHT);
};
